import { z } from "zod";

/** URL search params for the org chart. `person` deep-links the inspector
 *  to a membershipId; unknown ids are ignored by the route. */
export const orgChartSearchSchema = z
  .object({
    person: z.string().optional(),
  })
  .strict();

export type OrgChartSearch = z.infer<typeof orgChartSearchSchema>;
